module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAzUlEQVQoU43SwSpGQRQA4O/k7WQhysKSKAsLingBIhYWyi8ewcJCKQvJlg3vQqSORkMj/73XbGZxvjln5syJzHzCI5Yi4kPHisw8wyIuMB8R7+NsgRM4xQIuMTcORzmdmWUflfK4wmxEvLWZv2CDj7GCa8xExOt3/Ac2+AiruMF0RLyU2C/Y4EOs4RZTBf+BzVX2sYF7THbCmn0XW7gbgjvY7oWZuYfNztK1pwdY73xMRf3tqai/4RWdYLnzC/89FJl5XidncMye8TA0uJ+fEWefGKK2aQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left.png
// module id = fGwC
// module chunks = 1